import { z } from 'zod';
import {
  blockTypes,
  BlockNoteDocument,
} from '../../../components/BlockNoteEditor/schema';

type BlockNoteValue =
  | string
  | number
  | boolean
  | null
  | Array<BlockNoteValue>
  | { [key: string]: BlockNoteValue };

const blockNoteValueSchema: z.ZodType<BlockNoteValue> = z.lazy(() =>
  z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.null(),
    z.array(blockNoteValueSchema),
    z.record(blockNoteValueSchema),
  ]),
);

const blockNoteBlockSchema = z.intersection(
  z.object({
    id: z.string(),
    type: z.enum(blockTypes),
  }),
  z.record(blockNoteValueSchema),
);

export const blockNoteDocumentSchema: z.ZodType<BlockNoteDocument> =
  z.array(blockNoteBlockSchema);
